import { Dispatch, makeActionCreator, StateGetter } from "../../store/types";
import { Product, ProductLayout } from "../../models";
import { selectors as step1Selectors } from "../Step1";

export const SET_LAYOUTS = "layouts/SET_LAYOUTS";
export const SET_LAYOUTS_LOADING = "layouts/SET_LAYOUTS_LOADING";
export const SET_CHOSEN_LAYOUT = "layouts/SET_CHOSEN_LAYOUT";
export const RESET = "layouts/RESET";

export const setLayouts = makeActionCreator<
  ProductLayout[]
>(SET_LAYOUTS as typeof SET_LAYOUTS);
const setLayoutsLoading = makeActionCreator<
  boolean
>(SET_LAYOUTS_LOADING as typeof SET_LAYOUTS_LOADING);
export const setChosenLayout = makeActionCreator<
  ProductLayout | undefined
>(SET_CHOSEN_LAYOUT as typeof SET_CHOSEN_LAYOUT);
export const reset = makeActionCreator(RESET as typeof RESET);

export const fetchLayouts = () => async (
  dispatch: Dispatch,
  getState: StateGetter,
  http,
) => {
  dispatch(setLayoutsLoading(true));

  try {
    const product = step1Selectors.chosenProduct(getState()) as Product;
    const { data } = await http.get(`data/products/${product.id}/layouts`, {
      params: {
        limit: 100,
      },
    });
    dispatch(setLayouts(data));
  } catch (error) {
    throw error;
  } finally {
    dispatch(setLayoutsLoading(false));
  }
};



// WEBPACK FOOTER //
// ./src/routes/WizardLayoutChoice/actions.ts